class BannerClaroStore extends Widget {
    constructor() {
        super(".BannerClaroStore");
        this.element.classList.add("hidden");
        try {            
            this.image = this.element.querySelector(".mdn-Image-asset");
            this.title = this.element.querySelector(".mdn-Heading");
            this.description = this.element.querySelector(".description");
            this.caption = this.element.querySelector(".caption");
            this.cta = this.element.querySelector(".cta");

        } catch (error) {
            console.warn(error);
        }
        eHelpFramework.call('banners', (data)=> {
            let banner = data[0];
            try {                
                this.image.src = banner.urlImage;
                this.title.innerHTML = banner.title;
                this.description.innerHTML = banner.description;
                this.caption.innerHTML = banner.caption;
                this.cta.href = banner.urlLink;
                this.element.classList.remove("hidden");
            } catch (error) {
                console.warn(error);                
            }
        }, "GET")
    }
}
window.addEventListener("eHelpFrameworkReady", e => {
    eHelpFramework.widgets.push(new BannerClaroStore())
});